
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Layout, Card, Select, Modal } from 'antd';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import Sidebar from '../../Side_Bar/Admin_Side_Bar';
import Title from 'antd/lib/typography/Title';

const {Option} = Select;

const AddViewerForm = () => {
    const [customerList, setCustomerList]= useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [form] = Form.useForm();

    const [isChangeOk, setIsChangeOk] = useState(false);
    const [isChangeNotOk, setIsChangeNotOk] = useState(false);
    const navigate = useNavigate();
    
    const mainUrl        = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";

    const fetchTableData = async () => {
        try {
            const response = await fetch(`${mainUrl}/getAllTable?tableName=Customer`);
            if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        } catch (error) {
            console.error('Error fetching table data:', error);
            throw error;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const customerList = await fetchTableData();

                const customers = customerList.map(customer => ({
                    id: customer.customer_id,
                    name: customer.name,
                    // Add more properties as needed
                }));

                    setCustomerList(customers);
            } catch (error) {
                // Handle error, e.g., show an error message to the user
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const insertViewerUrl = `${mainUrl}/insertViewer`;

    const onFinish = (values) => {
        // Add logic to send the form data to the server or perform other actions
        console.log('Form submitted:', values);

        // // Make the fetch request here
        fetch(insertViewerUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: values.username,
            password: values.password,
            customer_id: values.customer_id
        }),
        })
        .then(response => response.json())
        .then(data => {
            console.log('Response from server:', data);
            setIsChangeOk(true);
        })
        .catch(error => {
            console.error('Error:', error);
            setIsChangeNotOk(true);
        });

        // Reset the form after submission
        form.resetFields();
    };

    const boxHeight = '50px';

    const handleModalOk = () => {
        // Handle the OK button in the modal
        // For example, navigate to another page or perform additional actions
        setIsChangeOk(false);
        navigate('/view_customer_viewer');
      };
    
      const handleModalNotOk = () => {
        // Handle the OK button in the modal
        // For example, navigate to another page or perform additional actions
        setIsChangeNotOk(false);
        navigate('/view_customer_viewer');
      };

    return (
        <Layout style={{ minHeight: '98vh' }}>
            <Sidebar location={location} />
            <Layout style={{ background: 'white'}}>
                <Title level={2} style={{marginTop: "0px", margin: "20px", fontWeight: "bold", textAlign: "left"}}>ADD VIEWER USER</Title>   
                <div style={{ maxWidth: '100%', margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
                    <Form
                        form={form}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 16 }}
                        onFinish={onFinish}
                        initialValues={{ remember: true }}
                    >

                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        <Form.Item 
                            name="username" 
                            rules={[{ required: true, message: 'Please enter the username' }]}
                            style={{ fontSize: '16px', flex: '1'}}>
                            <Input 
                            placeholder="Username" 
                            style={{ height: boxHeight, width: "150%"}}
                            />
                        </Form.Item>
                    </div>
            
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}> 
                        <Form.Item 
                        name="password" 
                        rules={[{ required: true, message: 'Please enter the password' }]}
                        style={{ fontSize: '16px', flex: '1'}}>
                            <Input 
                            placeholder="Password" 
                            style={{ height: boxHeight, width: "150%"}}
                            />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        <Form.Item 
                        name="customer_id" 
                        rules={[{ required: true, message: 'Please select a customer' }]}
                        style={{ fontSize: '16px', flex: '1'}}>
                            {loading ? (
                            <Select 
                            placeholder="Loading..." 
                            style={{ height: boxHeight, width: "150%" }} 
                            disabled />
                            ) : (
                            <Select 
                            placeholder="Company Name" 
                            style={{ height: boxHeight, width: "150%" }}>
                                {customerList.map(customer => (
                                <Option key={customer.id} value={customer.id}>
                                    {customer.name}
                                </Option>
                                ))}
                            </Select>
                            )}
                        </Form.Item>
                    </div>

                    <div style={{ flexWrap: 'wrap', position: 'fixed', right: 30}}>
                        <Form.Item>
                        <Button
                        type="primary" 
                        htmlType="submit" 
                        style={{ height: boxHeight, background: "#00308F" }}>
                            ADD
                        </Button>
                        </Form.Item>
                    </div>
                    </Form>

                    <Modal
                        title="Comapny Viewer Created"
                        visible={isChangeOk}
                        onOk={handleModalOk}
                        okText="OK"
                        closable={false}
                        cancelButtonProps={{ style: { display: 'none' } }}
                        centered
                        >
                        {/* Additional content in the modal */}
                        </Modal>

                        <Modal
                        title="Error Creating Company Viewer"
                        visible={isChangeNotOk}
                        onOk={handleModalNotOk}
                        okText="OK"
                        closable={false}
                        cancelButtonProps={{ style: { display: 'none' } }}
                        centered
                        >
                        {/* Additional content in the modal */}
                    </Modal>

                </div>
            </Layout>
        </Layout>
    );
};

export default AddViewerForm;
